var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRacquet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.4551 16.6225C31.3365 12.7412 31.9657 7.07754 28.8605 3.97239C25.7554 0.86723 20.0917 1.49644 16.2104 5.37776C12.3291 9.25908 11.6998 14.9227 14.805 18.0279C17.9102 21.1331 23.5738 20.5038 27.4551 16.6225Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4551 16.6225C31.3365 12.7412 31.9657 7.07754 28.8605 3.97239C25.7554 0.86723 20.0917 1.49644 16.2104 5.37776C12.3291 9.25908 11.6998 14.9227 14.805 18.0279C17.9102 21.1331 23.5738 20.5038 27.4551 16.6225Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54049 22.2925L4.12605 25.707C3.73553 26.0975 3.73553 26.7306 4.12605 27.1212L5.71174 28.7069C6.10226 29.0974 6.73543 29.0974 7.12595 28.7069L10.5404 25.2924C10.9309 24.9019 10.9309 24.2687 10.5404 23.8782L8.95471 22.2925C8.56418 21.902 7.93102 21.902 7.54049 22.2925Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74658 23.0863L14.8053 18.0276",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.833 2.0625V18.6225",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 3.37744V19.9374",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2104 8H30.7705",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8955 14H29.4555",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacquet);
export default __webpack_public_path__ + "static/media/Racquet.84af09378ae2eaa366689bacc3f9bf0a.svg";
export { ForwardRef as ReactComponent };